import { Menu, MenuItem, ListItemText } from "@mui/material";
import React, { useState } from "react";

export interface StatusOption {
  label: string;
  value: string;
  onClick?: (row: any, value: string) => void;
  permission?: boolean;
  color?: string;
}

interface DynamicStatusDropdownProps {
  row: any;
  currentStatus: string;
  statusOptions: StatusOption[];
  getStatusColor: (status: string) => { backgroundColor: string; color: string };
}

export const DynamicStatusDropdown = ({
  row,
  currentStatus,
  statusOptions,
  getStatusColor,
}: DynamicStatusDropdownProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // Filter status options based on permission (default to true if not specified)
  const visibleStatusOptions = statusOptions.filter(
    (option) => option.permission !== false
  );

  const statusColors = getStatusColor(currentStatus);

  return (
    <>
      <button
        onClick={handleClick}
        style={{
          backgroundColor: statusColors.backgroundColor,
          color: statusColors.color,
          border: "none",
          borderRadius: "20px",
          padding: "4px 12px",
          fontSize: "12px",
          fontWeight: 500,
          cursor: "pointer",
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {currentStatus}
        <i className="bi bi-chevron-down" style={{ fontSize: "10px" }}></i>
      </button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        PaperProps={{
          elevation: 3,
          sx: {
            fontFamily: "var(--bs-font-sans-serif) !important",
            "& *": {
              fontFamily: "var(--bs-font-sans-serif) !important",
            },
            "& .MuiMenuItem-root": {
              minHeight: "28px",
              padding: "4px 12px",
            },
            "& .MuiMenuItem-root .MuiListItemText-primary": {
              fontSize: "13px !important",
              fontWeight: "500 !important",
            },
          },
        }}
      >
        {visibleStatusOptions.map((option, index) => {
          const menuItemContent = (
            <ListItemText
              primary={option.label}
              sx={{
                fontFamily: "var(--bs-font-sans-serif) !important",
                fontSize: "13px",
                ...(option.color && { color: option.color }),
              }}
            />
          );

          return (
            <MenuItem
              key={index}
              onClick={() => {
                if (option.onClick) {
                  option.onClick(row, option.value);
                }
                handleClose();
              }}
              {...(option.color && { sx: { color: option.color } })}
            >
              {menuItemContent}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

